export const REPORT_CONFIG: any = {
    'internal-admin-all-school-summary': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: [],
        SEARCH_API: 'search/all-school-summary',
    },
    'internal-admin-all-alumni-report': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['VALIDATE','VERIFY_EMAIL', 'AUTO_LOGIN', 'DEACTIVATE', 'ACTIVATE', 'UPDATE', 'DELETE', 'MARKED_AS_DECEASED','ENGAGEMENT_API_RUN','MARK_AS_RECRUITER'],
        SEARCH_API: 'search/all-alumni-list',
        UPDATE_ACTION_LINK: (uuid: string) => `${process.env.REACT_APP_APP_BASE_URL}/alumni/${uuid}/profile`,
    },
    'internal-admin-user-entered-college': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: [],
        SEARCH_API: 'search/non-standard-colleges',
        UPDATE_ACTION_LINK: (uuid: string) => `${process.env.REACT_APP_APP_BASE_URL}/alumni/${uuid}/profile`,
    },
    'internal-admin-user-entered-exam': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: [],
        SEARCH_API: 'search/non-standard-exams',
        UPDATE_ACTION_LINK: (uuid: string) => `${process.env.REACT_APP_APP_BASE_URL}/alumni/${uuid}/profile`,
    },
    'internal-admin-benefits-report': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE'],
        SEARCH_API: 'search/benefits',
        UPDATE_ACTION_LINK: (uuid: string) => `${process.env.REACT_APP_APP_BASE_URL}/alumni/${uuid}/benefits`,
        TABLE_CLASS: "sticky_table_3_columns_noaction",
        TABLE_STYLE: {minWidth: '3000px'},
        TABLE_WIDTH: [250, 180, 250]
    },
    // action_master: [
    //     { code: 'VALIDATE', label: 'Validate' },
    //     { code: 'AUTO_LOGIN', label: 'Auto-login' },
    //     { code: 'DEACTIVATE', label: 'Deactivate' },
    //     { code: 'ACTIVATE', label: 'Activate' },
    //     { code: 'UPDATE', label: 'Update' },
    // ],
    'program-list': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE'],
        SEARCH_API: 'program/get-program-details',
        UPDATE_ACTION_LINK: (id: string) => `${process.env.REACT_APP_APP_BASE_URL}/program/edit-program/${id}`,
    },
    'program-report': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE'],
        SEARCH_API: 'program/get-program-details',
        UPDATE_ACTION_LINK: (id: string) => `${process.env.REACT_APP_APP_BASE_URL}/support/edit-program/${id}`,
    },
    'manage-lead': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','VIEW'],
        SEARCH_API: 'marketlead/getleadlist',
    },
    'manage-referral': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','VIEW'],
        SEARCH_API: 'marketlead/getreferrallist',
    },
    'manage-event': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','ACTION TO ACTIVE','ACTION TO INACTIVE'],
        SEARCH_API: 'marketevent/geteventlist',
        
    },
    'domain-data': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','DEACTIVATE','ACTIVATE'],
        SEARCH_API: 'program/get-program-details',
        UPDATE_ACTION_LINK: (id: string) => `${process.env.REACT_APP_APP_BASE_URL}/program/edit-program/${id}`,
    },
    'institute-list': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','Publish','Unpublish', 'Download Psychometric Test Report', 'View Commitment Dashboard', 'Alumni Watchlist Engine', 'HITL Review Queue'],
        SEARCH_API: 'institute/get-institute-details',
      //  UPDATE_ACTION_LINK: (id: string) => `${process.env.REACT_APP_APP_BASE_URL}/institute/${id}/basic-info`,
    },
    'company-list': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['Edit', 'View', 'Delete'],
        SEARCH_API: 'company/search',
    },
    'profilemarker-notes': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','DEACTIVATE','ACTIVATE'],
        // SEARCH_API: 'program/get-program-details',
        // UPDATE_ACTION_LINK: (id: string) => `${process.env.REACT_APP_APP_BASE_URL}/program/edit-program/${id}`,
    },
    'manage-psylink': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','VIEW'],
        SEARCH_API: 'marketlead/getleadlist',
    },
     'internal-admin-all-bas-report': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        //ROW_ACTION: ['UPDATE_3C', 'ASSIGN', 'RE-ASSIGN', 'VIEW_HISTORY', 'VIEW_NOTES', 'MAKE_STUDENT_/_PARENT_PRIMARY', 'RAISE_REMOVAL_REQUEST', 'CLOSE_CASE'],
        ROW_ACTION: ['UPDATE_3C', 'VIEW_HISTORY', 'VIEW_NOTES','SCHEDULE','RE-SCHEDULE', 'ON-DEMAND_SESSION', 'CLOSE_CASE','DOWNLOAD_TEST_REPORT'],
        SEARCH_API: 'all-bas-list',
        UPDATE_ACTION_LINK: (uuid: string) => `${process.env.REACT_APP_APP_BASE_URL}/alumni/${uuid}/profile`,
    },
    'student-profile': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: ['UPDATE','DEACTIVATE','ACTIVATE'],
        SEARCH_API: 'notes/get-counsellor-notes',
        UPDATE_ACTION_LINK: (id: string) => `${process.env.REACT_APP_APP_BASE_URL}/program/edit-program/${id}`,
    },
    'internal-admin-profile-marker': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: [],
        SEARCH_API: 'search/profile-marker-list',
        UPDATE_ACTION_LINK: (uuid: string, schoolId: string) => `${process.env.REACT_APP_APP_BASE_URL}/alumni/${uuid}/select-institute/${schoolId}/office-usage`,
    },
    'internal-admin-all-school-statistics': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: [],
        SEARCH_API: 'institute-tracker/all-school-statistics',
    },
    'inst-admin-grievance': {
        SHOW_SELECT_ALL: false,
        BULK_ACTION: [],
        ROW_ACTION: [],
        SEARCH_API: 'grievance/all-grievance-list',
    },
};
